import React from "react";

const ManagePermissionSideBar = ({ permissionSideBarActiveItem, setPermissionSideBarActiveItem }) => {
  const SideBarItems = [
    { title: "Group" },
    { title: "Permisson" },
    { title: "Grant Permisson" },
    { title: "Check User" },
  ];

  return (
    <div>
      <div className="text-[#1d4469] font-semibold text-[16px] mb-1">Manage Permission</div>
      <div className="bg-white shadow-md rounded-md w-[100%] mt-2 h-[556px]">
        <ul className="text-gray-600 rounded-md p-3">
          {SideBarItems.map((item, index) => (
            <li
              className={`hover:bg-cyan-900 hover:text-white cursor-pointer rounded mb-1 px-4 py-2 text-[13px] ${permissionSideBarActiveItem == item.title ? "bg-cyan-900 text-white" : ""}`}
              onClick={() => setPermissionSideBarActiveItem(item.title)}
            >
              {item?.title}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ManagePermissionSideBar;
